import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const StoryTeaser = () => (
  <section data-testid="story-teaser-section" className="bg-cream py-28 md:py-36 border-t border-ink/10">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-12 gap-12 items-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="md:col-span-5 overflow-hidden rounded-3xl border border-ink/10"
      >
        <img
          src="/images/story-quote.jpg"
          alt="PhudG Yellow Mustard Oil bottle in a warm Indian kitchen"
          loading="lazy"
          className="w-full aspect-[4/5] object-cover"
        />
      </motion.div>
      <div className="md:col-span-7">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-xs tracking-[0.4em] uppercase text-amberbrand mb-6"
        >
          Our Story
        </motion.p>
        <motion.blockquote
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="font-serif text-3xl md:text-5xl text-ink leading-tight tracking-tight mb-8"
        >
          "Why has something as fundamental as cooking oil become so difficult
          to <span className="italic text-olive">understand?</span>"
        </motion.blockquote>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.25 }}
          className="max-w-xl text-base font-light text-ink/60 leading-relaxed mb-8"
        >
          That question is why PhudG exists. We're building a food brand around
          ingredients, process and transparency — not complicated claims.
        </motion.p>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <Link
            to="/about"
            data-testid="story-teaser-link"
            className="inline-flex items-center gap-2 text-sm tracking-[0.2em] uppercase text-amberbrand hover:text-ink transition-colors duration-300"
          >
            Read our story <ArrowRight size={16} />
          </Link>
        </motion.div>
      </div>
    </div>
  </section>
);
